
export const environment = {
  production: true,
  apiUrlBase: 'https://cicerone.cms-iurban.com',
  urlWebSocket: 'wss://gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://gpt.cms-iurban.com/v2/get_conversation'
};
